import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AdminDomainCard = ({ domain }) => {
  const navigate = useNavigate();

  const colorClasses = {
    blue: 'from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700',
    purple: 'from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700',
    green: 'from-green-500 to-green-600 hover:from-green-600 hover:to-green-700',
    indigo: 'from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700',
    amber: 'from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700'
  };

  const bgColorClasses = {
    blue: 'bg-blue-50 border-blue-200',
    purple: 'bg-purple-50 border-purple-200',
    green: 'bg-green-50 border-green-200',
    indigo: 'bg-indigo-50 border-indigo-200',
    amber: 'bg-amber-50 border-amber-200'
  };

  const iconColorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    green: 'bg-green-100 text-green-600',
    indigo: 'bg-indigo-100 text-indigo-600',
    amber: 'bg-amber-100 text-amber-600'
  };

  return (
    <div
      onClick={() => navigate(domain?.path)}
      className={`${bgColorClasses?.[domain?.color]} border rounded-xl p-6 cursor-pointer transition-all duration-300 hover:shadow-lg hover:scale-[1.02] group`}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-12 h-12 ${iconColorClasses?.[domain?.color]} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform`}>
          <Icon name={domain?.icon} className="w-6 h-6" />
        </div>
        <Icon name="ArrowRight" className="w-5 h-5 text-gray-400 group-hover:text-gray-600 group-hover:translate-x-1 transition-all" />
      </div>
      <h3 className="text-xl font-bold text-gray-900 mb-2">{domain?.title}</h3>
      <p className="text-gray-600 text-sm mb-4 line-clamp-2">{domain?.description}</p>
      <div className="space-y-2">
        {domain?.metrics?.map((metric, index) => (
          <div key={index} className="flex items-center justify-between text-sm">
            <span className="text-gray-600">{metric?.label}</span>
            <span className="font-semibold text-gray-900">{metric?.value}</span>
          </div>
        ))}
      </div>
      <div className={`mt-4 pt-4 border-t border-gray-200`}>
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500 flex items-center gap-1">
            <Icon name="Lock" className="w-3 h-3" />
            Admin Access Required
          </span>
          <span className={`text-xs font-medium bg-gradient-to-r ${colorClasses?.[domain?.color]} bg-clip-text text-transparent`}>
            View Details →
          </span>
        </div>
      </div>
    </div>
  );
};

export default AdminDomainCard;